import { useAtomValue } from 'jotai';

import { EventTypeEnum } from '../../segment/types';
import { noop } from '../../utils';
import { getBundleCompletionState } from '../measures/utils';
import { AppointmentType } from '../schedule-preview/types';
import {
  patientShortIdToMeasuresFetchFailedAtom,
  patientShortIdWithFetchedMeasuresAtom,
  selectedClientInfoAtom,
  selectedClientMeasuresData,
} from '../state';
import { ClientInformationSectionWrapper as ClientInformationSectionConnected } from './ClientInformationSectionWrapper';
import { ClientInformationTab } from './ClientInformationTab';
import { EPrescribeMedicationsCardWrapper } from './EPrescribeMedicationsCardWrapper';
import { ProgressNoteSectionWrapper } from './ProgressNoteSectionWrapper';
import { ProviderResourcesCollapsibleContainerWrapper as ProviderResourcesCollapsibleContainer } from './ProviderResourcesCollapsibleContainerWrapper';
import { PreVisitSummaryCardWrapper } from './pre-visit-summary/PreVisitSummaryCardWrapper';
import { hasNewFormsAtomFamily } from './state';
import { useSendClientInfoTabViewTrackingEvent } from './useSendClientInfoTabViewTrackingEvent';
import { getAppointmentType } from './utils';

export function ClientInformationTabWrapper({ isEmpty }: { isEmpty: boolean }) {
  const selectedClient = useAtomValue(selectedClientInfoAtom);
  const patientShortId = selectedClient?.patientShortId;

  const hasNewForms = useAtomValue(hasNewFormsAtomFamily(patientShortId ?? ''));
  const measuresFetchedForPatient = useAtomValue(patientShortIdWithFetchedMeasuresAtom);
  const measuresFetchFailedForPatient = useAtomValue(patientShortIdToMeasuresFetchFailedAtom)[patientShortId ?? ''];
  const measureBundles = useAtomValue(selectedClientMeasuresData);
  const hasMeasuresData = !!patientShortId && measuresFetchedForPatient === patientShortId;
  const isMeasuresDataReady = !!patientShortId && (hasMeasuresData || !!measuresFetchFailedForPatient);
  const { state: bundleCompletionState } = getBundleCompletionState(measureBundles);

  useSendClientInfoTabViewTrackingEvent(
    patientShortId ?? '',
    EventTypeEnum.CLIENT_INFO,
    hasMeasuresData
      ? {
          hasMeasureBundles: measureBundles.length > 0,
          bundleCompletionState,
        }
      : {},
    isMeasuresDataReady,
  );

  return (
    <ClientInformationTab
      isEmpty={isEmpty}
      hasNewForms={hasNewForms}
      isFollowUpAppointment={getAppointmentType() === AppointmentType.FollowUp}
      progressNoteSectionComponent={ProgressNoteSectionWrapper}
      clientInformationSectionComponent={ClientInformationSectionConnected}
      clientActivityBetweenSessionsComponent={noop}
      providerResourcesCollapsibleContainerComponent={ProviderResourcesCollapsibleContainer}
      preVisitSummaryCardComponent={PreVisitSummaryCardWrapper}
      ePrescribeMedicationsCardComponent={EPrescribeMedicationsCardWrapper}
    />
  );
}
